export default "__VITE_ASSET__Bacz5Ax$__"